"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var axis_1 = tslib_1.__importDefault(require("../../../util/responsive/apply/axis"));
function responsiveAxis(layer) {
    var responsiveTheme = layer.getResponsiveTheme();
    var canvas = layer.canvas;
    // x-axis
    var x_responsiveAxis = new axis_1.default({
        plot: layer,
        responsiveTheme: responsiveTheme,
        dim: 'x',
    });
    // y-axis
    var y_responsiveAxis = new axis_1.default({
        plot: layer,
        responsiveTheme: responsiveTheme,
        dim: 'y',
    });
    canvas.draw();
}
exports.default = responsiveAxis;
//# sourceMappingURL=axis.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/area/apply-responsive/axis.js
// module id = 871
// module chunks = 37